import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getSupportView = (params) => {
    return axios.get(`${backendHost}/api/admin/support/view`, {params});
};

export {
    getSupportView
}